import { render } from "./mbm_page.vue?vue&type=template&id=e84cb79e"
import script from "./mbm_page.vue?vue&type=script&lang=js"
export * from "./mbm_page.vue?vue&type=script&lang=js"

import "./mbm_page.vue?vue&type=style&index=0&id=e84cb79e&lang=css"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__